import { inject, Injectable } from '@angular/core';

import type { CurrencyRatesSource, CurrencyRatesSourceId } from './currency-rates-source';
import { ScoCurrencyRatesSource } from './sco-currency-rates.source';
import { TestCurrencyRatesSource } from './test-currency-rates.source';

@Injectable({
  providedIn: 'root',
})
export class CurrencyRatesSourceRegistry {
  private readonly sources: Record<CurrencyRatesSourceId, CurrencyRatesSource> = {
    sco: inject(ScoCurrencyRatesSource),
    test: inject(TestCurrencyRatesSource),
  };

  get(id: CurrencyRatesSourceId): CurrencyRatesSource {
    return this.sources[id];
  }
}
